import { createContext, useContext } from "react";

export interface DialogExportContextType {
  visible: boolean;
  setVisible: (value: boolean) => void;
  status: "success" | "error" | "doing";
  numberRecord: number;
  setNumberRecord: (value: number) => void;
  onSubmit: () => void;
  setStatus: (value: "success" | "error" | "doing") => void;
  jobIdRunning: string;
  jobDetail: any;
  setJobDetail: (value: any) => void;
  minimize: boolean;
  setMinimize: (value: boolean) => void;
}

export const DialogExportContext = createContext<DialogExportContextType>(null);

export const useDialogExportContext = () => useContext(DialogExportContext);
